import type { WorkspaceResponse } from '@/model/workspace/dto.generated';
import { signedOut } from '@/viewmodel/features/user';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

interface WorkspacesState {
  currentWorkspace: WorkspaceResponse | undefined;
}

const initialState: WorkspacesState = {
  currentWorkspace: undefined,
};

const workspacesSlice = createSlice({
  name: 'workspaces',
  initialState,
  reducers: {
    setCurrentWorkspace: (state, action: PayloadAction<WorkspaceResponse>) => {
      state.currentWorkspace = action.payload;
    },
    clearCurrentWorkspace: (state) => {
      state.currentWorkspace = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signedOut, () => initialState);
  },
});

export const { setCurrentWorkspace, clearCurrentWorkspace } = workspacesSlice.actions;
export default workspacesSlice.reducer;

type WorkspacesRootState = { workspaces: WorkspacesState };

export const selectCurrentWorkspace = (state: WorkspacesRootState) =>
  state.workspaces?.currentWorkspace ?? null;
